import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ChangeDetectorRef,
  inject,
  input,
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import {
  ClassBookingService,
  ClientTrialService,
  TrialService,
  ToastMessageService
} from '@fitness-force/api';
import type {
  ClientTrial,
  ClientTrialById,
  ListClientTrial,
  MarkClientCheckedinRequest,
  MarkClientNoshowRequest,
  RemoveClientFromClassRequest,
  TENANTSINTERFACE,
  TrialBooking,
  TrialMaster,
} from '@fitness-force/models';
import { DateFormatedComponent } from '@fitness-force/grid-utility';
// import {
//   EntityStatusComponent,
//   StaffInfoComponent,
//   TrialUsedComponent,
//   TimeFormattedComponent,
//   BookingStatusComponent,
//   BookingActionsComponent,
//   AddButtonComponent,
// } from '@fitness-force/shared';
import { EntityStatusComponent } from '../../data-grid/utility/entity-status/entity-status.component';
import { TimeFormattedComponent } from '../../data-grid/utility/time-formatted/time-formatted.component';
import { BookingStatusComponent } from '../../data-grid/utility/booking-status/booking-status.component';
import { BookingActionsComponent } from '../../data-grid/utility/booking-actions/booking-actions.component';
import { AddButtonComponent } from '../../data-grid/utility/add-button/add-button.component';
import { TrialUsedComponent } from '../../data-grid/utility/trial-used/trial-used.component';
import { TrialTypeComponent } from '../../data-grid/utility/trial-type/trial-type.component';
import { StaffInfoComponent } from '../../staff/staff-info/staff-info.component';
import { Store } from '@ngrx/store';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TENANTS_INFO } from '@fitness-force/state';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { PopoverModule } from 'primeng/popover';
import { RippleModule } from 'primeng/ripple';
import { SkeletonModule } from 'primeng/skeleton';
import { StyleClassModule } from 'primeng/styleclass';

import { BehaviorSubject, NotFoundError, Observable } from 'rxjs';
import {
  DataGridComponent,
  NoClientTrialBookingComponent,
  NoClientTrialComponent,
  NoTrialHistoryComponent,
} from '@fitness-force/grid';
import { CreateClientTrialComponent } from '../../create-client-trial/create-client-trial.component';
import { ClientTrialStudioComponent } from '../../client-trial-studio/client-trial-studio.component';
import { ClientBookingStatus, ClassBookingCancellationType, Status, TrialType } from '@fitness-force/enum';
import { AppErrors } from '@fitness-force/models';
import { DateTimeFormatPipe } from '@fitness-force/pipes/datetime-format';

@Component({
  selector: 'client-trial-tab',
  templateUrl: './client-trial-tab.component.html',
  styleUrls: ['./client-trial-tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ToastMessageService],
  standalone: true,
  imports: [
    DividerModule,
    ButtonModule,
    RippleModule,
    StyleClassModule,
    DialogModule,
    PopoverModule,
    AvatarModule,
    SkeletonModule,
    DataGridComponent,
    CreateClientTrialComponent,
    ClientTrialStudioComponent,
    DateTimeFormatPipe,
    TranslateModule,
    AsyncPipe,
  ],
})
export class ClientTrialTabComponent implements OnInit {
  private readonly store = inject(Store);
  private readonly activatedRouter = inject(ActivatedRoute);
  private readonly clientTrialService = inject(ClientTrialService);
  private readonly trialMasterService = inject(TrialService);
  private readonly toastMessageService = inject(ToastMessageService);
  translate = inject(TranslateService);
  classBookingService = inject(ClassBookingService);
  cdr = inject(ChangeDetectorRef);

  getAccessTenantList$: Observable<any> | any | null;
  tenantId: number = 0;
  readonly clientId = input<number>(0);
  localClientId: number = 0;
  tableData: any[];
  clientTrialData$ = new BehaviorSubject<any[]>([]);
  clientTrialTablecolumns$ = new BehaviorSubject<any[]>([]);
  ClassBasedClientTrialData$ = new BehaviorSubject<TrialBooking[]>([]);
  ClassBasedClientTrialTablecolumns$ = new BehaviorSubject<any[]>([]);
  trialHistoryData$ = new BehaviorSubject<TrialBooking[]>([]);
  trialHistoryDataTablecolumns$ = new BehaviorSubject<any[]>([]);
  selecallTrialData: boolean = false;
  trialMasters: TrialMaster[] = [];
  trialMaster: TrialMaster | undefined;
  clientTrial: ClientTrialById | null;
  showClientSidebar: boolean = true;
  showSkeleton: boolean = true;
  showDaysBased: boolean = false;
  showClassBased: boolean = false;
  showDaysBasedTable: boolean = false;
  showClassBasedTable: boolean = false;
  showTrialHistory = new BehaviorSubject<boolean>(false);
  clientTrialForm!: UntypedFormGroup;
  emptyStateComponent$ = new BehaviorSubject<any>(NoClientTrialComponent);
  emptyStateComponentForTrialBooking$ = new BehaviorSubject<any>(
    NoClientTrialBookingComponent,
  );
  emptyStateComponentForHistory$ = new BehaviorSubject<any>(
    NoTrialHistoryComponent,
  );
  trialSinceDate: Date;
  clientColumn!: any;
  //showCreateTrialButton: boolean = false;

  loading: boolean = false;

  ngOnInit(): void {
    this.componentInit();
  }

  componentInit() {
    this.getAccessTenantList$ = this.store.select(TENANTS_INFO);
    this.getAccessTenantList$.subscribe((tenant: TENANTSINTERFACE) => {
      this.tenantId = tenant.selected_tenant.id;
      if (this.tenantId > 0) {
        this.store.dispatch({ type: 'ROUTER_GO' });
        this.getTrialMaster();
      }
    });
  }

  getTrialMaster() {
    this.loading = true;
    this.trialMasterService.getTrials(this.tenantId).subscribe({
      next: (response: any) => {
        if (response?.items) {
          this.trialMasters = response.items as TrialMaster[];
          this.trialMaster = this.trialMasters.find(
            (o) =>
              o.status == Status.Active ||
              o.status.toString() == Status[Status.Active],
          );
          this.getClientTrials();
          this.loading = false;
        } else {
          this.trialMaster = undefined;
          this.loading = false;
        }
        this.cdr.detectChanges();
      },
      error: (error) => {
        this.trialMaster = undefined;
        this.loading = false;
        this.toastMessageService.showError(error);
        this.cdr.detectChanges();
      },
    });
  }

  getClientTrials() {
    this.localClientId = this.activatedRouter.snapshot?.params['clientid']
      ? this.activatedRouter?.snapshot?.params['clientid']
      : this.clientId();
    this.clientTrialService
      .getClientTrials(this.localClientId)
      .subscribe({
        next: (response: ListClientTrial) => {
          this.showSkeleton = false;
          if (response.items.length > 0) {
            this.trialSinceDate = new Date(
              response.items[response.items.length - 1].updated_date,
            );
            if (this.trialMaster == undefined) {
              const lastTrialMstId = response.items.filter(
                (o) => o.trialmst_id,
              )[response.items.length - 1].trialmst_id;
              this.trialMaster = this.trialMasters.find(
                (o) => o.id == lastTrialMstId,
              );
            }
            this.setClientITrials(response.items);
            this.loading = false;
          } else {
            this.loading = false;
            this.emptyStateComponent$.next(NoClientTrialComponent);
          }
          this.cdr.detectChanges();
        },
        error: (error) => {
          this.showSkeleton = false;
          this.loading = false;
          if (error instanceof NotFoundError) {
            this.translate
              .get('common.errors.SERVER_SIDE.SOMETHING_WRONG')
              .subscribe((translation) => {
                this.toastMessageService.showErrorMessage(translation);
              });
          } else {
            this.translate
              .get('common.errors.SERVER_SIDE.SOMETHING_WRONG')
              .subscribe((translation) => {
                this.toastMessageService.showErrorMessage(translation);
              });
          }
          this.cdr.detectChanges();
        },
      });
  }

  getClientTrial(trialId: number) {
    this.showTrialHistory.next(true);
    this.localClientId = this.activatedRouter.snapshot?.params['clientid']
      ? this.activatedRouter?.snapshot?.params['clientid']
      : this.clientId();
    this.clientTrialService
      .getClientTrial(this.tenantId, this.clientId(), trialId)
      .subscribe({
        next: (response: ClientTrialById) => {
          this.clientTrial = response;
          this.trialHistoryData$.next(this.clientTrial.trial_booking || []);
          this.HistoryColumnsTransalation();
        },
        error: (error) => {
          this.showSkeleton = false;
          if (error instanceof NotFoundError) {
            this.translate
              .get('common.errors.SERVER_SIDE.SOMETHING_WRONG')
              .subscribe((translation) => {
                this.toastMessageService.showErrorMessage(translation);
              });
          } else {
            this.translate
              .get('common.errors.SERVER_SIDE.SOMETHING_WRONG')
              .subscribe((translation) => {
                this.toastMessageService.showErrorMessage(translation);
              });
          }
        },
      });
  }

  setClientITrials(trials: ClientTrial[]) {
    const enrichedTrials = trials.map((trial) => ({
      ...trial,
      trial_used_limit: this.getTrialUsedLimit(trial),
    }));

    const bookingTrials: any = [];
    enrichedTrials.forEach((o) => {
      if (o.trial_booking) {
        o.trial_booking.forEach((b, i) => {
          ((b.Type = 'class'),
            (b.BookingStatus = b.status),
            (b.total_used_trials = i + 1),
            (b.available_trials = o.available_trials));
          bookingTrials.push(b);
        });
      }
    });
    this.ClassBasedClientTrialData$.next(bookingTrials);
    this.clientTrialData$.next(enrichedTrials);
    this.GetClassBasedClientTrialColumns();
    this.GetClientTrialColumns();
    //}
    // else {
    //   this.clientTrialData$.next(trials);
    //   this.GetClientTrialColumns();
    // }
  }

  GetClientTrialColumns() {
    this.translate
      .get([
        'CLIENT_TRIAL.COLUMNS.DATE',
        'CLIENT_TRIAL.COLUMNS.END_DATE',
        'CLIENT_TRIAL.COLUMNS.PREFERED_TIME',
        'CLIENT_TRIAL.COLUMNS.TRIAL_USED',
        'CLIENT_TRIAL.COLUMNS.TRIAL_TYPE',
        'CLIENT_TRIAL.COLUMNS.STATUS',
      ])
      .subscribe((translations) => {
        this.ColumnsTransalation(translations);
      });
  }

  ColumnsTransalation(translations: any) {
    const clientColumn = {
      Date: translations['CLIENT_TRIAL.COLUMNS.DATE'],
      END_DATE: translations['CLIENT_TRIAL.COLUMNS.END_DATE'],
      PREFERED_TIME: translations['CLIENT_TRIAL.COLUMNS.PREFERED_TIME'],
      TRIAL_USED: translations['CLIENT_TRIAL.COLUMNS.TRIAL_USED'],
      TRIAL_TYPE: translations['CLIENT_TRIAL.COLUMNS.TRIAL_TYPE'],
      STATUS: translations['CLIENT_TRIAL.COLUMNS.STATUS'],
    };

    const columns: any = [
      {
        title: clientColumn.Date,
        classes: ' py-3 text-600 w-15rem white-space-nowrap',
        sortable: true,
        filterable: true,
        selectable: false,
        dataProperty: 'start_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: { KeyName: 'start_date', format: 'd MMM y' },
        },
      },
      {
        title: clientColumn.END_DATE,
        classes: ' py-3 text-600 w-15rem white-space-nowrap',
        sortable: true,
        filterable: true,
        selectable: false,
        dataProperty: 'end_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: { KeyName: 'end_date', format: 'd MMM y' },
        },
      },
      // {
      //   title: clientColumn.PREFERED_TIME,
      //   classes: ' py-3 text-600 w-15rem white-space-nowrap',
      //   sortable: true,
      //   filterable: true,
      //   selectable: false,
      //   dataProperty: 'start_date',
      //   type: 'component',
      //   data: {
      //     name: TimeFormattedComponent,
      //     additionData: true,
      //     aData: { keyName: 'start_date', format: 'h:mm a' },
      //   },
      // },
      {
        title: clientColumn.TRIAL_TYPE,
        classes: ' py-3 text-600 w-15rem white-space-nowrap',
        sortable: true,
        filterable: true,
        selectable: false,
        dataProperty: 'trial_type',
        type: 'component',
        data: { name: TrialTypeComponent },
      },
      {
        title: clientColumn.TRIAL_USED,
        classes: ' py-3 text-600 w-15rem white-space-nowrap',
        sortable: true,
        filterable: true,
        selectable: false,
        dataProperty: 'total_used_trials',
        type: 'component',
        data: {
          name: TrialUsedComponent,
          additionData: true,
          aData: {
            used_key: 'total_used_trials',
            total_key: 'trial_used_limit',
          },
        },
      },
      {
        title: clientColumn.STATUS,
        classes: ' py-3 text-600 w-15rem white-space-nowrap',
        sortable: true,
        filterable: true,
        selectable: false,
        dataProperty: 'status',
        type: 'component',
        data: { name: EntityStatusComponent },
      },
      {
        title: '',
        classes: 'py-3 text-600 w-15rem white-space-nowrap',
        sortable: true,
        filterable: true,
        selectable: false,
        dataProperty: 'status',
        type: 'component',
        data: {
          name: AddButtonComponent,
          additionData: true,
          aData: { label: 'Book a trial class' },
        },
      },
    ];
    // if(this.trialMaster && (this.trialMaster.type == TrialType.ClassBased || this.trialMaster.type.toString() == TrialType[TrialType.ClassBased])){
    //   columns.push({
    //     title: "",
    //     classes: 'py-3 text-600 w-15rem white-space-nowrap',
    //     sortable: true,
    //     filterable: true,
    //     selectable: false,
    //     dataProperty: 'status',
    //     type: 'component',
    //     data: {
    //       name: AddButtonComponent,
    //       additionData: true,
    //       aData: { label: 'Book a trial class'},
    //     },
    //   });
    // }
    this.clientTrialTablecolumns$.next(columns);
  }

  HistoryColumnsTransalation() {
    this.translate
      .get([
        'CLIENT_TRIAL.HISTORY_COLUMNS.TIME',
        'CLIENT_TRIAL.HISTORY_COLUMNS.DATE',
        'CLIENT_TRIAL.HISTORY_COLUMNS.TRAINER',
      ])
      .subscribe((translations) => {
        this.GetTrialHistoryColumns(translations);
      });
  }

  GetTrialHistoryColumns(translations: any) {
    const columns = {
      Time: translations['CLIENT_TRIAL.HISTORY_COLUMNS.TIME'],
      Date: translations['CLIENT_TRIAL.HISTORY_COLUMNS.DATE'],
      Trainer: translations['CLIENT_TRIAL.HISTORY_COLUMNS.TRAINER'],
    };
    this.trialHistoryDataTablecolumns$.next([
      {
        title: columns.Time,
        classes: 'py-3 white-space-nowrap',
        sortable: true,
        filterable: true,
        selectable: false,
        dataProperty: 'end_date',
        type: 'component',
        data: {
          name: TimeFormattedComponent,
          additionData: true,
          fetch_key: 'end_date',
          aData: { keyName: 'end_date', format: 'h:mm a' },
        },
      },
      {
        title: columns.Date,
        classes: 'py-3 white-space-nowrap',
        sortable: true,
        filterable: true,
        selectable: false,
        dataProperty: 'start_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: { KeyName: 'start_date', format: 'd MMM y' },
        },
      },
      {
        title: columns.Trainer,
        classes: 'py-3 white-space-nowrap',
        sortable: true,
        filterable: true,
        selectable: false,
        dataProperty: 'trainer_id',
        type: 'component',
        data: { name: StaffInfoComponent },
      },
    ]);
  }

  GetClassBasedClientTrialColumns() {
    this.translate
      .get([
        'CLIENT_TRIAL.COLUMNS.CLASS_TYPE',
        'CLIENT_BOOKING.DATETIME',
        'CLIENT_TRIAL.HISTORY_COLUMNS.TRAINER',
        'CLIENT_TRIAL.COLUMNS.SESSIONS',
        'CLIENT_TRIAL.COLUMNS.STATUS',
      ])
      .subscribe((translations) => {
        this.ColumnsClassBasedTransalation(translations);
      });
  }

  ColumnsClassBasedTransalation(translations: any) {
    const clientColumn = {
      CLASSTYPE: translations['CLIENT_TRIAL.COLUMNS.CLASS_TYPE'],
      DATE_TIME: translations['CLIENT_BOOKING.DATETIME'],
      TRAINER: translations['CLIENT_TRIAL.HISTORY_COLUMNS.TRAINER'],
      SESSION: translations['CLIENT_TRIAL.COLUMNS.SESSIONS'],
      STATUS: translations['CLIENT_TRIAL.COLUMNS.STATUS'],
    };
    this.ClassBasedClientTrialTablecolumns$.next([
      {
        title: clientColumn.CLASSTYPE,
        classes: 'py-3 text-600 w-15rem white-space-nowrap',
        sortable: true,
        filterable: true,
        selectable: false,
        dataProperty: 'type_name',
        type: 'default',
      },
      {
        title: clientColumn.DATE_TIME,
        classes: ' py-3 text-600 w-15rem white-space-nowrap',
        sortable: true,
        filterable: true,
        selectable: false,
        dataProperty: 'start_date',
        type: 'component',
        data: {
          name: TimeFormattedComponent,
          additionData: true,
          fetch_key: 'start_date',
          aData: { keyName: 'start_date', format: 'd MMM yyyy h:mm a' },
        },
      },
      // {
      //   title: clientColumn.SESSION,
      //   classes: ' py-3 text-600 w-15rem white-space-nowrap',
      //   sortable: true,
      //   filterable: true,
      //   selectable: false,
      //   dataProperty: 'total_used_trials',
      //   type: 'component',
      //   data: { name: TrialUsedComponent,
      //     additionData: true,
      //     aData: { used_key: 'total_used_trials', total_key: 'max_trial_class' },
      //    },
      // },
      {
        title: clientColumn.TRAINER,
        classes: 'py-3 white-space-nowrap',
        sortable: true,
        filterable: true,
        selectable: false,
        dataProperty: 'trainer_id',
        type: 'component',
        data: { name: StaffInfoComponent },
      },
      {
        title: clientColumn.STATUS,
        classes: ' py-3 text-600 w-15rem white-space-nowrap',
        sortable: true,
        filterable: true,
        selectable: false,
        dataProperty: 'BookingStatus',
        type: 'component',
        data: { name: BookingStatusComponent },
      },
      {
        title: '',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'actions',
        type: 'component',
        data: {
          name: BookingActionsComponent,
          additionData: true,
          aData: [
            'compsession',
            'remove',
            'checkin',
            'noshow',
            'reschedule',
            'cancel',
            'attended',
          ],
        },
      },
    ]);
  }

  createNewTrial() {
    if (
      this.trialMaster &&
      (this.trialMaster.status == Status.Active ||
        this.trialMaster.status.toString() == Status[Status.Active]) &&
      (this.trialMaster.type == TrialType.DaysBased ||
        this.trialMaster.type.toString() == TrialType[TrialType.DaysBased])
    ) {
      this.showDaysBased = true;
      this.showClassBased = false;
    } else if (
      this.trialMaster &&
      (this.trialMaster.status == Status.Active ||
        this.trialMaster.status.toString() == Status[Status.Active]) &&
      (this.trialMaster.type == TrialType.ClassBased ||
        this.trialMaster.type.toString() == TrialType[TrialType.ClassBased])
    ) {
      this.showClassBased = true;
      this.showDaysBased = false;
      //this.showCreateTrialButton = !this.clientTrialData$.getValue().some(o => o.trial_type == 'ClassBased' && o.status.toLowerCase() == 'active');
    } else {
      this.translate
        .get('CLIENT_TRIAL.TRIAL_NOT_CONFIGURED')
        .subscribe((translation) => {
          this.toastMessageService.showErrorMessage(translation);
        });
    }
  }

  CloseTralHistory() {
    this.showTrialHistory.next(false);
  }

  createTrial(event: any) {
    this.getClientTrials;
  }

  onActionEventForTrial(event: any) {
    switch (event.action.toLowerCase()) {
      case 'add':
        this.showClassBased = true;
        break;
      case 'createclienttrial':
        this.createNewTrial();
        break;
      case 'opentrialhistory':
        this.getClientTrial(event.columnData.id);
        break;
    }
  }

  onActionEvent(event: any) {
    switch (event.action.toLowerCase()) {
      case 'edit':
        break;
      case 'status':
        break;
      case 'delete':
        break;
      case 'createclienttrial':
        this.createNewTrial();
        break;
      case 'opentrialhistory':
        this.getClientTrial(event.columnData.id);
        break;
      case 'remove': {
        this.RemoveClientFromClass(event.columnData.class_id);
        break;
      }
      case 'checkin':
        {
          this.MarkClientCheckedIn(event.columnData.class_id);
        }
        break;
      case 'noshow':
        {
          this.MarkClientNoshow(event.columnData.class_id);
        }
        break;
      case 'createclientrialclassbooking':
        this.showClassBased = true;
        break;
    }
  }

  RemoveClientFromClass(classId: number) {
    const removeClientFromClass: RemoveClientFromClassRequest = {
      client_ids: [this.clientId()],
      cancellation_type: ClassBookingCancellationType.None,
    };
    this.classBookingService
      .RemoveClientsToClass(this.tenantId, classId, removeClientFromClass)
      .subscribe({
        next: () => {
          this.translate
            .get('SCHEDULE.VIEWCLASS.MSG.REMOVE_MSG')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });

          this.getClientTrials();
        },
        error: (error: AppErrors) => {
          this.ShowToastErrors(error);
        },
      });
  }

  MarkClientCheckedIn(classId: number) {
    const clientCheckedInRequest: MarkClientCheckedinRequest =
      {} as MarkClientCheckedinRequest;
    const clientids: number[] = [];
    clientids.push(this.clientId());
    clientCheckedInRequest.client_ids = clientids;
    this.classBookingService
      .MarkCheckedIn(this.tenantId, classId, clientCheckedInRequest)
      .subscribe({
        next: () => {
          this.translate
            .get('SCHEDULE.VIEWCLASS.MSG.MARK_CHECKEDIN_MSG')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
          this.getBookings.forEach((o) => {
            if (o.class_id == classId) {
              ((o.status = ClientBookingStatus.Attended),
                (o.BookingStatus = ClientBookingStatus.Attended));
            }
          });
          this.ClassBasedClientTrialData$.next(this.getBookings);
          this.GetClassBasedClientTrialColumns();
        },
        error: (error: AppErrors) => {
          this.ShowToastErrors(error);
        },
      });
  }

  MarkClientNoshow(classId: number) {
    const clientNoShowRequest: MarkClientNoshowRequest =
      {} as MarkClientNoshowRequest;
    const clientids: number[] = [];
    clientids.push(this.clientId());
    clientNoShowRequest.client_ids = clientids;
    this.classBookingService
      .MarkNoShow(this.tenantId, classId, clientNoShowRequest)
      .subscribe({
        next: () => {
          this.translate
            .get('SCHEDULE.VIEWCLASS.MSG.MARK_NOSHOW_MSG')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
          this.getBookings.forEach((o) => {
            if (o.class_id == classId) {
              ((o.status = ClientBookingStatus.NoShow),
                (o.BookingStatus = ClientBookingStatus.NoShow));
            }
          });
          this.ClassBasedClientTrialData$.next(this.getBookings);
          this.GetClassBasedClientTrialColumns();
        },
        error: (error: AppErrors) => {
          this.ShowToastErrors(error);
        },
      });
  }

  closeEvent(event: any) {
    this.showDaysBased = false;
    this.showClassBased = false;
    if (event.reloadData) {
      this.getClientTrials();
    }
  }

  ShowToastErrors(error: any) {
    this.toastMessageService.showError(error);
  }

  get getBookings() {
    return this.ClassBasedClientTrialData$.getValue();
  }

  private getTrialUsedLimit(trial: ClientTrial): number {
    const trialType = trial.trial_type ?? trial.type;
    if (trialType === 'DaysBased') {
      return trial.max_trial_validity;
    }
    return trial.max_trial_class;
  }

  get isClassBasedActive() {
    return (
      (this.trialMaster?.type == TrialType.ClassBased ||
        this.trialMaster?.type.toString() == TrialType[TrialType.ClassBased]) &&
      (this.trialMaster?.status == Status.Active ||
        this.trialMaster?.status.toString() == Status[Status.Active])
    );
  }

  get isDaysBasedActive() {
    return (
      (this.trialMaster?.type == TrialType.DaysBased ||
        this.trialMaster?.type.toString() == TrialType[TrialType.DaysBased]) &&
      (this.trialMaster?.status == Status.Active ||
        this.trialMaster?.status.toString() == Status[Status.Active])
    );
  }

  get showCreateTrialButton() {
    return (
      this.isClassBasedActive &&
      !this.clientTrialData$
        .getValue()
        .some(
          (o) =>
            o.trial_type == 'ClassBased' && o.status.toLowerCase() == 'active',
        )
    );
  }
}
